import React from 'react';
import Drawer, { FooterSpacer } from '../../Drawer';
import Button from '../../Button';
import Field from '../../Field';
import { EXPENSE_CATEGORY_MAX } from '../../../domain/expenses';
import s from './categories.module.css';

// New / rename a category. `editing` is 'new' or the record being renamed.
//
// `error` is the duplicate-name refusal (#144). Save stays enabled and the
// message arrives under the Name field on submit (#116), as MMS's calendar
// category drawer does (#129). The empty name still greys the button;
// `expenseCategoryErrors` says why.

export default function CategoryFormDrawer({
  editing, name, onNameChange, type, onTypeChange, onSave, onClose, error,
}) {
  const isNew = editing === 'new';

  return (
    <Drawer
      open={Boolean(editing)}
      onClose={onClose}
      title={isNew ? 'New Category' : 'Edit Category'}
      width={560}
      footer={(
        <>
          <FooterSpacer />
          <Button variant="secondary" onClick={onClose}>Cancel</Button>
          <Button disabled={!name.trim()} onClick={onSave}>Save</Button>
        </>
      )}
    >
      <div className={s.formBody}>
        {/* `htmlFor`/`id` because a <Field> renders a bare <label>: without the
            pair it names nothing, and the refusal below it is announced as
            loose text rather than as this field's error. */}
        <Field label="Name" htmlFor="expense-category-name" hint="e.g. Sheet Music" error={error}>
          {/* firestore.rules requires `0 < label.size() < 100` on this
              collection, so the bound is here too, and a long name is refused
              on screen (#115, #145). */}
          <input
            id="expense-category-name"
            className={s.input}
            value={name}
            maxLength={EXPENSE_CATEGORY_MAX}
            autoFocus
            data-error={error ? 'true' : undefined}
            onChange={(e) => onNameChange(e.target.value)}
          />
        </Field>

        {isNew ? (
          <div className={s.formField}>
            <Field label="Type">
              <select className={s.input} value={type} onChange={(e) => onTypeChange(e.target.value)}>
                <option value="expense">Expense</option>
                <option value="revenue">Revenue</option>
              </select>
            </Field>
          </div>
        ) : (
          // Type is fixed after creation: flipping it would move every entry
          // filed under it from one side of the books to the other.
          <div className={s.formNote}>
            This is {editing?.type === 'revenue' ? 'a revenue' : 'an expense'} category.
            Renaming it relabels every entry filed under it.
          </div>
        )}
      </div>
    </Drawer>
  );
}
